import { forwardRef, useRef, useState } from 'react';

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * An HOC that injects a `composing` prop into the wrapped component that
 * indicates whether IME composition is in progress.
 */
export const IMEAware = Component => {
  const IMEAwareComponent = /*#__PURE__*/forwardRef((props, ref) => {
    const handlers = {};

    /* eslint-disable react-hooks/rules-of-hooks */
    const [composing, setComposing] = useState(false);
    ['onCompositionStart', 'onCompositionEnd'].forEach(handlerKey => {
      const receivedHandlerRef = useRef(undefined);
      const handlerRef = useRef(undefined);
      if (!handlerRef.current || receivedHandlerRef.current !== props[handlerKey]) {
        receivedHandlerRef.current = props[handlerKey];
        handlerRef.current = evt => {
          setComposing(handlerKey === 'onCompositionStart');
          if (props[handlerKey]) {
            var _props;
            (_props = props[handlerKey]) === null || _props === void 0 || _props.call(props, evt);
          }
        };
      }
      handlers[handlerKey] = handlerRef.current;
    });
    /* eslint-enable react-hooks/rules-of-hooks */

    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, handlers, {
      composing: composing,
      ref: ref
    }));
  });
  return IMEAwareComponent;
};